import { Button } from "@/atoms/button/Button";
import ArrowRight from "@/atoms/icon/icons/arrow_right.svg";
import { useTranslation } from "@/core/i18n";
import { cn } from "@/lib/utils";

import { getPersonaImage } from "../assets/getPersonaImage";

export interface AdonisChatCTAInPDPProps {
  variant: "adonis" | "aria";
  onClick: () => void;
  className?: string;
  /** Replaces the detail-page prompt ("Have a question?"), e.g. on a shop list. */
  question?: string;
  /** Replaces the detail-page button label ("Ask {name}"). */
  buttonLabel?: string;
}

export const AdonisChatCTAInPDP = ({
  variant,
  onClick,
  className,
  question,
  buttonLabel,
}: AdonisChatCTAInPDPProps) => {
  const { t } = useTranslation();
  const name = variant === "adonis" ? "Adonis" : "Aria";

  return (
    <div className={cn("w-full overflow-hidden rounded-2xl bg-[#F1EBE3] p-5 desk:p-6", className)}>
      <div className="grid grid-cols-[64px_minmax(0,1fr)] items-center gap-x-4 gap-y-4 desk:grid-cols-[96px_minmax(0,1fr)] desk:gap-x-6">
        <div className="relative aspect-square overflow-hidden rounded-full bg-[radial-gradient(ellipse_at_bottom,#C9B59B,transparent_75%)] desk:row-span-2 desk:aspect-[4/5] desk:rounded-b-none desk:rounded-t-full">
          <img
            src={getPersonaImage(name).clear}
            alt=""
            className="absolute bottom-0 h-full w-full object-contain object-bottom"
          />
        </div>
        <div className="min-w-0">
          <p className="text-body3 text-secondary">{t("assistantHeader.aiAdvisor", { name })}</p>
          <p className="mt-1 font-serif text-h3 text-primary">
            {question ?? t("adonisChatCTAInPDP.haveAQuestion")}
          </p>
        </div>
        <div className="col-span-2 desk:col-span-1 desk:col-start-2">
          <Button
            style="white"
            size="medium"
            endIconSVG={ArrowRight}
            iconSize="xsmall"
            onClick={onClick}
          >
            {buttonLabel ?? t("adonisChatCTAInPDP.askButton", { name })}
          </Button>
        </div>
      </div>
    </div>
  );
};
